import React, { useState } from "react";
import ReactInputMask from "react-input-mask";
import { StyledInputMask } from "./styles";
import { InputMaskTypes } from "./types";

export function InputMask({ inputRef, name, value, mask, placeholder, onChange, }: InputMaskTypes) {
	let dynamicMask = typeof mask === 'string' ? mask : '';

	function responsiveMask() {
		if(name === "liquid_inc") {
			//from thousand to hundred thousand
			if(value.length > 0 && value.length < 10) {
				return "R$9.999,99";
			}

			if(value.length >= 10 && value.length < 11) {
				return "R$99.999,99";
			}

			if(value.length >= 11 && value.length < 12) {
				return "R$999.999,99";
			}

			//from ten million to one hundred million
			if(value.length >= 12 && value.length < 13) {
				return "R$9.999.999,99";
			}

			if(value.length >= 13 && value.length < 14) {
				return "R$99.999.999,99";
			}

			if(value.length >= 14 && value.length < 15) {
				return "R$999.999.999,99";
			}


			//limit condition
			if(value.length >= 15) {
				return "R$999.999.999,99";
			}
		}

		if(name === "liq_inc_month") {
			//from thousand to hundred thousand
			if(value.length > 0 && value.length < 10) {
				return "R$9.999,99";
			}

			if(value.length >= 10 && value.length < 11) {
				return "R$99.999,99";
			}

			if(value.length >= 11 && value.length < 12) {
				return "R$999.999,99";
			}

			//from ten million to one hundred million
			if(value.length >= 12 && value.length < 13) {
				return "R$9.999.999,99";
			}

			if(value.length >= 13 && value.length < 14) {
				return "R$99.999.999,99";
			}

			if(value.length >= 14 && value.length < 15) {
				return "R$999.999.999,99";
			}


			//limit condition
			if(value.length >= 15) {
				return "R$999.999.999,99";
			}
		}

		if(name === "irpf") {
			//from thousand to hundred thousand
			if(value.length > 0 && value.length < 10) {
				return "R$9.999,99";
			}

			if(value.length >= 10 && value.length < 11) {
				return "R$99.999,99";
			}

			if(value.length >= 11 && value.length < 12) {
				return "R$999.999,99";
			}

			//from ten million to one hundred million
			if(value.length >= 12 && value.length < 13) {
				return "R$9.999.999,99";
			}

			if(value.length >= 13 && value.length < 14) {
				return "R$99.999.999,99";
			}

			if(value.length >= 14 && value.length < 15) {
				return "R$999.999.999,99";
			}


			//limit condition
			if(value.length >= 15) {
				return "R$999.999.999,99";
			}
		}

		if(name === "brute_inc") {
			//from thousand to hundred thousand
			if(value.length > 0 && value.length < 10) {
				return "R$9.999,99";
			}

			if(value.length >= 10 && value.length < 11) {
				return "R$99.999,99";
			}

			if(value.length >= 11 && value.length < 12) {
				return "R$999.999,99";
			}

			//from ten million to one hundred million
			if(value.length >= 12 && value.length < 13) {
				return "R$9.999.999,99";
			}

			if(value.length >= 13 && value.length < 14) {
				return "R$99.999.999,99";
			}

			if(value.length >= 14 && value.length < 15) {
				return "R$999.999.999,99";
			}

			//limit condition
			if(value.length >= 15) {
				return "R$999.999.999,99";
			}
		}

		return dynamicMask!
	}
	return (
		<StyledInputMask
			// as={ReactInputMask}
			name ={name}
			value = {value}
			mask={responsiveMask()}
			maskPlaceholder={null}
			className='input text-input'
			placeholder={placeholder}
			ref = {inputRef}
			onChange= {onChange}
		/>
	)
}